import React from "react";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import RelevoAdministrativoForm from "./RelevoAdministrativoForm";
import UploadRelevoAdministrativo from "./UploadRelevoAdministrativo";

const RelevoAdministrativoModal = ({ toggle, isOpen, upload, clientId, reloadRelevos, infoRow }) => {
  const { id } = infoRow || {};
  return (
    <div style={{ fontFamily: "Nunito" }}>
      <Modal size="lg" isOpen={isOpen}>
        <ModalHeader toggle={toggle}>Nuevo Relevo Administrativo</ModalHeader>
        <ModalBody style={{ backgroundColor: "#f8f8f8" }}>
          {upload ? (
            <UploadRelevoAdministrativo clientId={clientId} toggle={toggle} reloadRelevos={reloadRelevos} relevoId={id} />
          ) : (
            <RelevoAdministrativoForm clientId={clientId} toggle={toggle} reloadRelevos={reloadRelevos} relevoId={id} />
          )}
        </ModalBody>
      </Modal>
    </div>
  );
};

export default RelevoAdministrativoModal;
